import React from "react";
import InstructorBanner from "../Component/Cpit7.jpg";
import "./InstructorPage.css";

const InstructorPage = () => {
  return (
    <div className="instructor-page">
      {/* Hero Banner */}
      <div className="instructor-banner">
        <img
          src={InstructorBanner}
          alt="Our Instructors"
          className="banner-img"
        />
      </div>

      {/* About Instructors Section */}
      <div className="instructor-about container py-5">
        <h2 className="fw-bold text-center mb-4 text-primary">
          About Our Instructors
        </h2>

        <p className="about-text">
          At <strong>Career Point of Information Technology (CPIT)</strong>, our
          instructors are the foundation of our success. Each member of our
          teaching team is not only a certified professional but also a mentor
          dedicated to shaping the future of our students. With years of
          hands-on experience in their respective fields, they bring
          real-world insights and practical knowledge into the classroom.
        </p>

        <p className="about-text">
          Our trainers believe that learning should go beyond theory. They
          ensure that every student receives personalized guidance, practical
          exposure, and the motivation to achieve excellence. From technical
          expertise to communication and professional skills, our instructors
          nurture students to become confident and career-ready individuals.
        </p>

        <p className="about-text">
          At <strong>CPIT</strong>, we believe in the power of mentorship and
          quality education. Our instructors continuously update their teaching
          methodologies to align with the latest industry trends and government
          skill development standards, ensuring that students receive education
          that is both relevant and effective.
        </p>

        <p className="about-text mb-0">
          Learning from our expert instructors means learning from professionals
          who genuinely care about your success. Together, we aim to empower
          every learner to build a strong foundation for a brighter career.
        </p>
      </div>
    </div>
  );
};

export default InstructorPage;
